import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconFeedbackSmall = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={41}
    fill="none"
    viewBox="0 0 40 41"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-feedback-small_svg__a)"
      d="M20.156 21.87c1.407 0 2.5 1.171 2.5 2.5 0 1.405-1.093 2.5-2.5 2.5a2.468 2.468 0 0 1-2.5-2.5c0-1.329 1.094-2.5 2.5-2.5Zm0-2.5c-1.015 0-1.875-.782-1.875-1.876v-8.75c0-1.015.86-1.875 1.875-1.875 1.016 0 1.875.86 1.875 1.875v8.75c0 1.094-.86 1.875-1.875 1.875ZM35 .62c2.813 0 5 2.265 5 5v22.343c0 2.656-2.266 4.922-5 4.922H23.75l-9.766 7.343c-.625.391-1.484 0-1.484-.78v-6.485H5c-2.813 0-5-2.188-5-4.922V5.619c0-2.734 2.188-5 5-5h30Zm1.328 27.5V5.62c0-.626-.625-1.25-1.25-1.25h-30c-.703 0-1.25.624-1.25 1.25v22.5c0 .702.547 1.25 1.25 1.25h11.25v4.687l6.25-4.688h12.5c.625 0 1.25-.547 1.25-1.25Z"
    />
    <defs>
      <linearGradient
        id="icon-feedback-small_svg__a"
        x1={40}
        x2={0.238}
        y1={0.619}
        y2={40.618}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF968D" />
        <stop offset={0.18} stopColor="#E2645A" />
        <stop offset={0.73} stopColor="#D83832" />
        <stop offset={1} stopColor="#AD3529" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconFeedbackSmall;
